module.exports = {
	"_args": [
		[
			"bitcore-lib@0.15.0",
			"C:\\Users\\nktpa\\Desktop\\atlantida-solutions"
		]
	],
	"_from": "bitcore-lib@0.15.0",
	"_id": "bitcore-lib@0.15.0",
	"_inBundle": false,
	"_integrity": "sha512-AeXLWhiivF6CDFzrABZHT4jJrflyylDWTi32o30rF92HW9msfuKpjzrHtFKYGa9w0kNVv5HABQjCB3OEav4PhQ==",
	"_location": "/bitcore-lib",
	"_phantomChildren": {
		"brorand": "1.1.0",
		"hash.js": "1.1.3",
		"hmac-drbg": "1.0.1",
		"minimalistic-assert": "1.0.0",
		"minimalistic-crypto-utils": "1.0.1"
	},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "bitcore-lib@0.15.0",
		"name": "bitcore-lib",
		"escapedName": "bitcore-lib",
		"rawSpec": "0.15.0",
		"saveSpec": null,
		"fetchSpec": "0.15.0"
	},
	"_requiredBy": [
		"/bitcore-mnemonic",
		"/eth-lightwallet"
	],
	"_resolved": "https://registry.npmjs.org/bitcore-lib/-/bitcore-lib-0.15.0.tgz",
	"_spec": "0.15.0",
	"_where": "C:\\Users\\nktpa\\Desktop\\atlantida-solutions",
	"author": {
		"name": "BitPay",
		"email": "dev@bitpay.com"
	},
	"browser": {
		"request": "browser-request"
	},
	"bugs": {
		"url": "https://github.com/bitpay/bitcore-lib/issues"
	},
	"dependencies": {
		"bn.js": "=4.11.8",
		"bs58": "=4.0.1",
		"buffer-compare": "=1.1.1",
		"elliptic": "=6.4.0",
		"inherits": "=2.0.1",
		"lodash": "=4.17.4"
	},
	"description": "A pure and powerful JavaScript Bitcoin library.",
	"devDependencies": {
		"bitcore-build": "git+https://github.com/bitpay/bitcore-build.git#d4e8b2b2f1e2c065c3a807dcb6a6250f61d67ab3",
		"brfs": "^1.2.0",
		"chai": "^1.10.0",
		"gulp": "^3.8.10",
		"sinon": "^1.13.0"
	},
	"homepage": "https://github.com/bitpay/bitcore-lib#readme",
	"keywords": [
		"bitcoin",
		"transaction",
		"address",
		"p2p",
		"ecies",
		"cryptocurrency",
		"blockchain",
		"payment",
		"bip21",
		"bip32",
		"bip37",
		"bip69",
		"bip70",
		"multisig"
	],
	"license": "MIT",
	"main": "index.js",
	"name": "bitcore-lib",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/bitpay/bitcore-lib.git"
	},
	"scripts": {
		"build": "gulp",
		"coverage": "gulp coverage",
		"lint": "gulp lint",
		"test": "gulp test"
	},
	"version": "0.15.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/bitcore-lib/package.json
// module id = 1207
// module chunks = 0